import { render, staticRenderFns } from "./Management.vue?vue&type=template&id=bde3dac8&scoped=true&"
import script from "./Management.vue?vue&type=script&lang=ts&"
export * from "./Management.vue?vue&type=script&lang=ts&"
import style0 from "./Management.vue?vue&type=style&index=0&id=bde3dac8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde3dac8",
  null
  
)

export default component.exports